const clientID = 'ebe4872a1cd3a322b1e0761268c8770a';
const scopes = ['military'];
const IdMeEndpoint = (redirect, language) => `https://api.id.me/${language}/oauth/authorize?client_id=${clientID}&redirect_uri=${redirect}&response_type=code&scope=${scopes}`;

export { IdMeEndpoint, clientID, scopes };
//# sourceMappingURL=Constants.js.map
